// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","scope-fas":"fas_scope-fas","isMobile":"fas_isMobile","article_count":"fas_article_count"};